module.exports = __webpack_public_path__ + "static/media/location.1d0cd341.svg";